export var descendingComparator = function (a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
};
export var getComparator = function (order, orderBy) {
    if (orderBy === 'status') {
        return order === 'desc'
            ? function (a, b) { return -descendingComparator(a, b, orderBy); }
            : function (a, b) { return descendingComparator(a, b, orderBy); };
    }
    return order === 'desc'
        ? function (a, b) { return descendingComparator(a, b, orderBy); }
        : function (a, b) { return -descendingComparator(a, b, orderBy); };
};
export var sortedRows = function (rows, comparator, levelCheck) {
    if (levelCheck === void 0) { levelCheck = false; }
    return rows.sort(function (a, b) {
        if (levelCheck && a.level !== b.level) {
            return 0;
        }
        return comparator(a, b);
    });
};
